import { useMemo, useState } from "react";

import { getUniqKwNames } from "app/pages/activation/helpers/home/keywords";

import type { KeywordsGroupsSchema } from "../../useKeywordsGroups";

export const useDuplicateGate = (keywordsGroups: KeywordsGroupsSchema | undefined) => {
    const [duplicateTopics, setDuplicateTopics] = useState<string[]>([]);

    const existingNormalized = useMemo(() => getUniqKwNames(keywordsGroups), [keywordsGroups]);

    const splitUniquesAndDups = (selectedTopics: string[]) => {
        const acc = selectedTopics.reduce(
            (res, raw) => {
                if (existingNormalized.has(raw) || res.seenInBatch.has(raw)) {
                    res.dups.push(raw);
                } else {
                    res.uniques.push(raw);
                    res.seenInBatch.add(raw);
                }
                return res;
            },
            { uniques: [] as string[], dups: [] as string[], seenInBatch: new Set<string>() },
        );

        if (acc.dups.length) {
            setDuplicateTopics((prev) => Array.from(new Set([...prev, ...acc.dups])));
        }

        return acc;
    };
    return { duplicateTopics, setDuplicateTopics, splitUniquesAndDups };
};
